export enum Platform {
    INSTAGRAM = 'Instagram',
    FACEBOOK = 'Facebook',
    LINKEDIN = 'LinkedIn',
    PINTEREST = 'Pinterest',
    GOOGLE = 'Google',
    YOUTUBE = 'Youtube',
    OTHER = 'Other',
    CUSTOM = 'Custom',
}

export const PLATFORM_ARRAY = [
    Platform.INSTAGRAM,
    Platform.FACEBOOK,
    Platform.LINKEDIN,
    Platform.PINTEREST,
    Platform.GOOGLE,
    Platform.YOUTUBE,
    Platform.OTHER,
];

export const DELIVERABLE_PLATFORM_ARRAY = [
    Platform.INSTAGRAM,
    Platform.FACEBOOK,
    Platform.LINKEDIN,
    Platform.PINTEREST,
    Platform.GOOGLE,
    Platform.YOUTUBE,
    Platform.OTHER,
];

export const SUB_DELIVERABLE_PLATFORM_ARRAY = [
    Platform.INSTAGRAM,
    Platform.FACEBOOK,
    Platform.LINKEDIN,
    Platform.PINTEREST,
    Platform.GOOGLE,
    Platform.YOUTUBE,
    Platform.CUSTOM,
    Platform.OTHER,
];

export enum AssetType {
    CUSTOM = 'Custom',
    LANDING_PAGE_MOCKUP = 'Landing Page Mockup',
    POST = 'Post',
    DISPLAY_AD_RECTANGLE = 'Display Ad Rectangle',
    DISPLAY_AD_SQUARE = 'Display Ad Square',
    AD_POST = 'Ad Post',
    SQUARE_POST = 'Square Post',
    THUMBNAIL = 'Thumbnail',
    REAL_ESTATE_LISTING_FLYER = 'Real Estate Listing Flyer',
    BUSINESS_CARD = 'Business Card',
    AD_STORY = 'Ad Story',
    STORY = 'Story',
    EMAIL_BANNER = 'Email Banner',
    EMAIL_NEWSLETTER = 'Email Newsletter',
    MEME = 'Meme',
    EVENT_FLYER = 'Event Flyer',
    AD_NEWS_FEED = 'Ad News Feed',
    COVER_IMAGE = 'Cover Image',
    ONE_PAGER = 'One Pager',
    WEBINAR_SCRIPT = 'Webinar Script',
    EMAIL = 'Email',
    BLOG_POST = 'Blog Post',
    BLOG_COVER_IMAGE = 'Blog Cover Image',
    AD = 'Ad',
    STANDARD_PIN = 'Standard Pin',
    SHOPPING_AD = 'Shopping Ad',
}

export enum DeliverableTask {
    CREATE_NEW_AD = 'Design',
    PRODUCT_PHOTOGRAPHY = 'Product Photo',
    RESIZE = 'Resize',
    VARIANT = 'Variant',
}

export const getAssetTypeForPlatform = (platform: string | undefined): AssetType[] => {
    const assetTypes: AssetType[] = [];

    if (platform === Platform.INSTAGRAM) {
        assetTypes.push(AssetType.POST, AssetType.STORY, AssetType.AD_POST, AssetType.AD_STORY);
    } else if (platform === Platform.FACEBOOK) {
        assetTypes.push(
            AssetType.POST,
            AssetType.STORY,
            AssetType.AD_NEWS_FEED,
            AssetType.AD_STORY,
        );
    } else if (platform === Platform.LINKEDIN) {
        assetTypes.push(AssetType.POST, AssetType.SQUARE_POST, AssetType.AD);
    } else if (platform === Platform.PINTEREST) {
        assetTypes.push(AssetType.STANDARD_PIN, AssetType.SHOPPING_AD);
    } else if (platform === Platform.GOOGLE) {
        assetTypes.push(AssetType.DISPLAY_AD_SQUARE, AssetType.DISPLAY_AD_RECTANGLE);
    } else if (platform === Platform.YOUTUBE) {
        assetTypes.push(AssetType.THUMBNAIL);
    } else if (platform === Platform.CUSTOM) {
        assetTypes.push(AssetType.CUSTOM);
    } else if (platform === Platform.OTHER) {
        assetTypes.push(
            AssetType.ONE_PAGER,
            AssetType.EVENT_FLYER,
            AssetType.EMAIL_BANNER,
            AssetType.REAL_ESTATE_LISTING_FLYER,
            AssetType.BUSINESS_CARD,
            AssetType.MEME,
            AssetType.LANDING_PAGE_MOCKUP,
            AssetType.BLOG_POST,
            AssetType.WEBINAR_SCRIPT,
            AssetType.EMAIL,
        );
    } else {
        assetTypes.push(AssetType.AD);
    }
    return assetTypes;
};
